import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-brand-charcoal selection:bg-brand-orange/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <WhatYouGet data-id="element-4" />
      <WhoIsFor data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <ProofSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <OfferBlock data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}